<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/Ueditor/NewDUeditorEditor'
export default {
  name: 'NewDContentEditor',
  extends: compoment
}
</script>
